import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import localStorageService from 'services/storage'
import { Select } from 'antd'
import { selectCurrentUser, selectCurrentZone, selectAvailableZones, setCurrentZone } from 'store/global'
import styles from './ZoneSelect.scss'
import history from 'utils/history'

interface Zone {
  id: number
  name: string
}

interface User {
  id: number
  [key: string]: any
}

const ZoneSelect: React.FC = () => {
  const dispatch = useDispatch()

  const currentUser = useSelector(selectCurrentUser) as User
  const currentZone = useSelector(selectCurrentZone) as Zone | null
  const availableZones = useSelector(selectAvailableZones) as Zone[]

  const sortedZones = useMemo(() => {
    return [...availableZones].sort((a, b) => a.name.localeCompare(b.name))
  }, [availableZones])

  const onZoneSelect = (zoneId: string) => {
    const nextZoneId = parseInt(zoneId)
    const nextZone = sortedZones.find(({ id }) => id === nextZoneId)

    if (nextZone) {
      dispatch(setCurrentZone({ zone: nextZone }))
      localStorageService.setLastSelectedZoneForUser(currentUser, nextZone)
      history.push('/dashboard')
    }
  }

  return (
    <div className={styles.container}>
      <Select
        value={currentZone?.id?.toString()}
        onChange={onZoneSelect}
        style={{ width: '100%' }}
        showSearch
        placeholder='Select zone'
        optionFilterProp='children'
        filterOption={(input, option) =>
          String(option?.children || '')
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {sortedZones.map(zone => (
          <Select.Option key={zone.id} value={zone.id.toString()}>
            {zone.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  )
}

export default ZoneSelect